module.exports = __webpack_public_path__ + "static/media/left_wreath.0ae49bff.png";